import React, { useCallback } from 'react';
import { useParams } from 'react-router';

import { Box, IconButton } from '@mui/material';
import { SECTION_CONTAINER_ATTR } from 'app/services/loanNavigation/loanNavigation.constants';
import SectionPresenceWrapper from 'app/shared/componentsRestyled/common/SectionPresenceWrapper';
import {
  LeftRightExpandedIcon,
  LeftRightIcon,
} from 'app/shared/componentsRestyled/coreDesignSystem/icons';

import { FINANCIAL_INFO_VIEWS_PATHS } from '../../FinancialInfo.constants';
import { TablePropTypes } from '../FinancialInfoBody.constants';

import { AREA_ID_BY_TABLE_NAME } from './TableWrapper.constants';
import { getExpandButtonStyles, wrapperStyles } from './TableWrapper.styles';
import { TableWrapperTestIds } from './TableWrapper.testIds';

const TableWrapper = ({ onToggle, tableName, children }) => {
  const { subtab } = useParams();

  const areaId = AREA_ID_BY_TABLE_NAME[tableName];

  const isExpanded = subtab === tableName;

  const onClickExpandButton = useCallback(
    () => onToggle(isExpanded ? FINANCIAL_INFO_VIEWS_PATHS.ALL_VIEWS : tableName),
    [onToggle, isExpanded, tableName],
  );

  if (subtab !== tableName && subtab !== FINANCIAL_INFO_VIEWS_PATHS.ALL_VIEWS) {
    return null;
  }

  return (
    <Box sx={wrapperStyles} {...(areaId ? { [SECTION_CONTAINER_ATTR]: areaId } : {})}>
      {areaId && <SectionPresenceWrapper areaId={areaId} />}
      {children}
      <IconButton
        disableRipple
        data-testid={TableWrapperTestIds.EXPAND_BUTTON}
        sx={getExpandButtonStyles(isExpanded)}
        onClick={onClickExpandButton}
      >
        {isExpanded ? <LeftRightExpandedIcon size={18} /> : <LeftRightIcon size={18} />}
      </IconButton>
    </Box>
  );
};

TableWrapper.propTypes = TablePropTypes;

export default TableWrapper;
